import { BackgroundColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const Container = styled.div``;

const CollapseContainer = styled.div`
	padding: 10px;
	background-color: ${BackgroundColors.PrimaryAlt};
	border-radius: ${BorderRadius.SM}px;
	margin-bottom: 10px;
`;

export { Container, CollapseContainer };
